import * as React from "react";
const SvgFiRrK = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-k_svg__a)">
      <path
        fill="#062147"
        d="m21.781 22.375-7.543-9.429 7.594-11.391a1.001 1.001 0 0 0-1.664-1.11L12.465 12H4V1C3.994-.308 2.006-.307 2 1v11.978a.07.07 0 0 0 0 .044V23c.006 1.308 1.995 1.307 2 0v-9h8.519l7.7 9.625a1 1 0 0 0 1.562-1.25"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-k_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrK;
